import React, { useEffect, useState } from "react";
import { codigoIntitucion } from "../config/constantes";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import Alerta from "./Alerta";


const ModalCambioPrograma = () => {
  const {
    listadoPeriodo,
    listadoPrograma,
    setObtenerDatosEstudiante,
    obtenerDatosEstudianteSinFiltro,
    setSeleccionPrograma,
    seleccionPrograma,
    seleccionPeriodo, setSeleccionPeriodo
  } = useMatricula();



  const [alerta, setAlerta] = useState({});
  const [vecesSeleccion, setVecesSeleccion] = useState(false);

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  let codIntitucion = Number(codigoIntitucion);



  useEffect(() => {
    if (vecesSeleccion == false) {
      let defaultPrograma = listadoPrograma.filter((data, index) => {
        if (index == 0) {
          return data;
        }
      })
      if (defaultPrograma.length > 0) {
        let { cprograma } = defaultPrograma[0];
        setSeleccionPrograma(cprograma);
        setVecesSeleccion(true);
      }
    }
  }, [listadoPrograma])



  useEffect(() => {
    let defaultPeriodo = listadoPeriodo.filter((data, index) => {
      if (index == 0) {
        return data;
      }

    })


    if (defaultPeriodo.length > 0) {
      let { cperiodo } = defaultPeriodo[0];
      setSeleccionPeriodo(cperiodo);
      let seleccionPerid = document.querySelector("#seleccionPeriodo");
      if (seleccionPerid) {
        seleccionPerid.value = cperiodo
      }
    }

  }, [listadoPeriodo]);

  const handleSubmit = (e) => {
    const cerrarModal = document.querySelector("#cerrar");

    e.preventDefault();
    let datosFiltro = obtenerDatosEstudianteSinFiltro.filter((buscar) => {
      if (
        Number(buscar.cperiodo) == Number(seleccionPeriodo) &&
        Number(buscar.cprograma) == Number(seleccionPrograma) && buscar.cinstitucion == codIntitucion
      ) {
        return buscar;
      }
    });

    if (datosFiltro.length > 0) {
      setAlerta({});
      const [dataFiltrada] = datosFiltro;
      setObtenerDatosEstudiante(dataFiltrada);

      cerrarModal.click();
    } else {
      setAlerta({
        msg: `${lbl_validacion_msj_seleccione_programa}.`,
        error: true,
      });
    }
  };

  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        programa_matricula: obtenerLabelEtiqueta(
          "lbl_programa_matricula",
          listadoEtiquetas
        ),
        seleccionar_programa: obtenerLabelEtiqueta(
          "lbl_programa_matricula_seleccionar_programa",
          listadoEtiquetas
        ),
        seleccionar_periodo: obtenerLabelEtiqueta(
          "lbl_programa_matricula_seleccionar_periodo",
          listadoEtiquetas
        ),
        cambiar: obtenerLabelEtiqueta(
          "lbl_global_cambiar",
          listadoEtiquetas
        ),
        lbl_validacion_msj_seleccione_programa: obtenerLabelEtiqueta(
          "lbl_validacion_msj_seleccione_programa",
          listadoEtiquetas
        ),

      });
    }
  }, [listadoEtiquetas]);
  const { programa_matricula, seleccionar_programa, seleccionar_periodo, cambiar, lbl_validacion_msj_seleccione_programa } = etiquetas;
  return (
    <div
      className="modal fade programa"
      id="exampleModal"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <form className="modal-content" onSubmit={handleSubmit}>
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {programa_matricula}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="cerrar"
            />
          </div>
          <div className="modal-body">
            <div className="row">
              {alerta.error && (
                <div className="form-group">
                  <Alerta alerta={alerta} />
                </div>
              )}
              <div className="form-group">
                <label className="fw-medium mb-2">{seleccionar_programa}:</label>
                <select
                  className="form-select form-select-sm"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setSeleccionPrograma(e.target.value);
                  }}
                  defaultValue={listadoPrograma > 0 && listadoPrograma[0]?.cprograma || 0}

                >
                  {listadoPrograma.map((data) => {
                    return (
                      <option key={data.cprograma} value={data.cprograma}>
                        {data.dprograma}
                      </option>
                    );
                  })}


                </select>
              </div>
              <div className="form-group mt-3">
                <label className="fw-medium mb-2">{seleccionar_periodo}:</label>
                <select
                  className="form-select form-select-sm"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setSeleccionPeriodo(e.target.value);
                  }}
                  id="seleccionPeriodo"

                >

                  {listadoPeriodo.map((data) => {
                    return (
                      <option key={data.cperiodo} value={data.cperiodo}>
                        {data.dperiodo}
                      </option>
                    );
                  })}

                </select>

              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button id="cambiar" type="submit" className="btn btn-primary">
              {cambiar}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCambioPrograma;
